import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app-services/auth-service/auth.service';
import { HallTicketDialogComponent } from '@app-modules/feature/products/hall-ticket-dialog/hall-ticket-dialog.component';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import { UserService } from '@app-services/user/user.service';
import { SubscribemodalComponent } from '@app-shared/components/subscribemodal/subscribemodal.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { environment } from 'src/environments/environment';
import { DashboardService } from '@app-services/dashboard/dashboard.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { allowedExamNamesCT, allSubjectsInOrder, apisDataCacheKeys, neetNewVerTypes, irregularExamtypes, timeBoundTypes, tenant, curTenantDetails, showBannerGrades, examDisplayNames, CMSTestType, examgraceTimeConstant } from '@app-constants/app.constants';
import { registerNow, } from 'src/app/helpers/methods';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommunicationMessageService } from '@app-services/communication-message/communication-message.service';
import { filterCMSData, getCourseName, getDateFromTestSpan, getExamName, isCurrentTimeGreaterExamEndtime, timeConvert, timeDifferencetestTimeandserver, totalTimeTakebySchdule } from 'src/app/helpers/functions';
import { FocusExamComponent } from '../new-dashboard/dialogs/focus-exam/focus-exam.component';
// import { StartLearnModalComponent } from '../../start-learn-modal/start-learn-modal.component';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { availableForAttempt, canRegisterTimeChecking, displayFormatedDateTime, attemptTestNow, comingSoon, attemptTestNowSCTB } from '@app-modules/feature/dashboard/component/info-box/info-box.component';
import { extend } from 'lodash-es';
import { ExamService } from '@app-services/test/exam.service';
import { timer } from 'rxjs';
import { TaskTimer } from 'tasktimer';
import { MyactivityService } from 'src/app/core/services/myactivity.service';
import { FirebaseAnalyticsService } from '@app-services/firebase-analytics/firebase-analytics.service';

export function calculateForJEEADV(inp: any = {}) {
  let { examName, detailedReportPaper, overallTests, testsByScheduleIdIn, studentExamResultIn, attemptedTestsByScheduleIdIn, report, totalScores = {}, timeNeeded = true, highestScoreNeeded = true } = inp;
  if (examName == "JEEADVANCED") {
    let attemptedTestsByScheduleId = {}, testsByScheduleId = {}, testsById = {}, results = [], resultsScheduleIds = [];
    if (detailedReportPaper == 'Combined') {
      testsByScheduleId = testsByScheduleIdIn;
      attemptedTestsByScheduleId = attemptedTestsByScheduleIdIn;
      results = studentExamResultIn;
      resultsScheduleIds = Object.keys(attemptedTestsByScheduleId)
      report.completedtests = resultsScheduleIds?.filter(e => attemptedTestsByScheduleId?.[e]?.length > 1)?.length || 0;

    } else {

      overallTests.filter((testData: any) => {
        const detailedReportPaperNum = detailedReportPaper == 'Paper 1' ? 1 : 2;
        if (Number(testData?.papernum) == detailedReportPaperNum) {
          const scId = testData.scheduleid;
          if (!testsByScheduleId[scId]) {
            testsByScheduleId[scId] = [];
          }
          testsByScheduleId[scId].push(testData);
          testsById[testData._id] = testData;
          return true;
        }
      });

      results = studentExamResultIn.filter((test: any) => {
        const testrow = testsById[test.testrule_id];
        if (testrow) {
          if (!attemptedTestsByScheduleId[test.testformat_id]) {
            attemptedTestsByScheduleId[test.testformat_id] = [];
          }
          attemptedTestsByScheduleId[test.testformat_id].push(test);
          return true;
        }
      });
      resultsScheduleIds = Object.keys(attemptedTestsByScheduleId || {})
      report.completedtests = resultsScheduleIds?.filter(e => attemptedTestsByScheduleId[e].length)?.length || 0;
    }
    report.totaltests = Object.keys(testsByScheduleId).length;
    report.totaltimespent = 0;

    report.highestscore = 0;
    report.outofscore = 0;
    if (timeNeeded) {
      let timeSpentInMin = results.reduce((totalTime: any, test: any) => {
        if (test.grand_total.timespent) {
          return totalTime + test.grand_total.timespent;
        } else {
          return totalTime + 0;
        }
      }, 0);
      report.totaltimespent = timeConvert(timeSpentInMin);
    }
    if (highestScoreNeeded) {
      let highestScore = 0;
      let highestScoreTestSchedulId;
      if (resultsScheduleIds.length) {
        highestScore = -99999;
        resultsScheduleIds?.forEach((e) => {
          let score = 0;
          attemptedTestsByScheduleId[e]?.forEach(element => {
            score += element.grand_total.score;
          });
          if (score >= highestScore) {
            highestScore = score;
            highestScoreTestSchedulId = e;
          }
        });
      }

      if (highestScoreTestSchedulId) {
        report.highestscore = highestScore;
        report.outofscore =
          attemptedTestsByScheduleId[highestScoreTestSchedulId]?.reduce((acc, element) => {
            return acc + (totalScores[element.testrule_id] != undefined ? totalScores[element.testrule_id] : getTotalScore(element));
          }, 0);
      }
    }
  }
}
export function filterJEEAdvancedPapers(paper: any) {
  //if(!(this.chaptersFetched && this.testsFetched && this.resultsFetched)) return;
  this.calculateForJEEADV({ examName: this.examName, detailedReportPaper: this.detailedReportPaper = paper, overallTests: this.overallTests, testsByScheduleIdIn: this.testsByScheduleId, studentExamResultIn: this.studentExamResult, attemptedTestsByScheduleIdIn: this.attemptedTestsByScheduleId, report: this.report, totalScores: this.totalScores });
  this.report = {
    ...this.report
  }
}

export function registerNowPreStep(tests: Array<any>, examtype: any, registeredCount: Number = 0) {
  const examname = getExamName(examtype);
  examtype = (examname == '') ? examtype : examname;
  if (examtype == "GRANDTEST") {
    const detail = this.userService.getMobileAndName()
    let studentid = this.tenant == 'srichaitanya' ? localStorage.getItem('studentid') : detail?.isdCode + "" + localStorage.getItem('studentid')
    const body = {
      tenantid: this.tenant,
      studentid,
    }

    this.testListService.getstudenthalltickets(body).subscribe((resp: any) => {
      if (resp && resp.length) {
        let examName = localStorage.getItem("targetExamName") as string;
        //@ts-ignore
        examName = (examName || "").replaceAll(" ", "")?.toUpperCase()
        let hallticketExists = false;
        resp.forEach(element => {
          if (element?.examname?.replaceAll(" ", "").toUpperCase() == examName && (element?.studentid == studentid || "+" + (element?.studentid) == studentid)) {
            hallticketExists = true;
          }
          if (hallticketExists) {

            registerNow.call(this, tests, examtype);
          } else {

            gotoDialog.call(this, tests, examtype);
          }
        });
      } else {
        gotoDialog.call(this, tests, examtype);
      }
    }, () => {

      gotoDialog.call(this, tests, examtype);
    })

  } else {

    if (examtype == "ILTS" || examtype == "TIMEBOUND" || examtype == "New NEET Timebound" || examtype == "SCHOLARSHIPTEST" ||  examtype == "RAPTimeBound" ||  ['RAPDailyTest','cf03ca38-34e8-11ed-a261-0242ac120002', 'b9f32e18-34e8-11ed-a261-0242ac120002'].indexOf(examtype) !=-1 ||['1eda50ee-65be-11ed-9022-0242ac120002', 'a851d6b8-65bd-11ed-9022-0242ac120002', 'd0e5c8fa-65bd-11ed-9022-0242ac120002'].indexOf(examtype) !=-1) {

      //grandTests are free
      if (examtype == 'TIMEBOUND') {
        this.gaService.webEngageEvent({
          'event': 'ILTS Register Now',
          'Test name': tests[0].schedulename
        })
      }
      this.testListService.isUserSubscribed(examtype, tests).then((resp: any) => {
        if (this.tenant != 'srichaitanya') {
          if (resp) {
            // if (examtype == "SCHOLARSHIPTEST") {

            //   this.route.navigate(['/subscription', { 'from': 'assementilite', ...tests[0] }])
            // } else {
              var componentInstance = this.modalservice.open(SubscribemodalComponent, {
                centered: true, size: 'sm', windowClass: 'subscription-modal-custom',
              })
              componentInstance.componentInstance.data = {...tests?.[0],examtype:examtype}
            // }
            return;
          }
        }
        registerNow.call(this, tests, examtype);
      });
    } else {
      registerNow.call(this, tests, examtype);
    }
  }
}

export function gotoDialog(tests: Array<any>, examtype: any) {
  let ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    windowClass: 'ASM_hl_tkt_modal-content'

  };
  const modalComp = this.modalservice.open(HallTicketDialogComponent, ngbModalOptions);
  let examName = localStorage.getItem("targetExamName") as string;
  modalComp.componentInstance.examName = examName;
  modalComp.result.finally(() => { registerNow.call(this, tests, examtype); })
}

export function getTotalScore(test:any) {
  const examname = (Array.isArray(test?.TestType[0])) ? getExamName(test?.TestType[0]) : getExamName(test?.TestType);
  const coursename = getCourseName(test.examtype);
  if (test.questionanswer) {
    if(irregularExamtypes.indexOf(examname) > -1 || (coursename != "NEET" && getCourseName(test.examtype) != "JEEMAIN")) {
      return allSubjectsInOrder.reduce((p: any, s: any) =>{
        return p + Number(test[s.toLowerCase()+'total'] || 0);
      }, 0);
    } else {
      let count = test.questionanswer.reduce((totalQs: any, questionanswer: any) => {
        return totalQs + (questionanswer.questions || questionanswer.responses || []).length;
      },0);
      if(examname == "67521" || examname == "CYOT"  ) {
        return count;
      }
      if(coursename == "JEEMAIN") {
        count -= 15;
      } else if(neetNewVerTypes.indexOf(examname) > -1) {
        count -= 20;
      }
      return 4 * count;
    }
  } else {
    return 0;
  }
}

@Component({
  selector: 'app-assessment-board',
  templateUrl: './assessment-board.component.html',
  styleUrls: ['./assessment-board.component.css']
})
export class AssessmentBoardComponent implements OnInit, OnDestroy {
  tenant: any = tenant;
  overallTests = [];
  studentExamResult = [];
  report: any = {
    'totaltests': 0,
    'completedtests': 0,
    'totaltimespent': 0,
    'highestscore': 0,
    'outofscore': 0
  };
  infoBoxes = [];
  token: any;
  detail: any;
  profilePhoto: any;
  userData: any;
  latestTimeboundTests: any = {};
  latestTimeboundTestInterval: any = null;
  examName: any = 'NEET';
  enrolledExamsCount: number = 0;
  testsByScheduleId: any = {};
  attemptedTestsByScheduleId: any = {};
  totalScores: any = {};
  detailedReportPaper: any = "Combined";
  portal: any = environment.portal;
  showNewUserPopup: boolean;
  showBanner: boolean;
  showInfoBox: boolean = false;
  calculateForJEEADV = calculateForJEEADV;
  filterJEEAdvancedPapers = filterJEEAdvancedPapers;
  registerNowPreStep = registerNowPreStep;
  timeConvert = timeConvert;
  isCurrentTimeGreaterExamEndtime = isCurrentTimeGreaterExamEndtime;
  availableForAttempt = availableForAttempt;
  canRegisterTimeChecking = canRegisterTimeChecking;
  displayFormatedDateTime = displayFormatedDateTime;
  attemptTestNow = attemptTestNow;
  attemptTestNowSCTB = attemptTestNowSCTB;
  getTotalScore = getTotalScore;
  comingSoon = comingSoon;
  timeDifferencetestTimeandserver = timeDifferencetestTimeandserver
  displayExamName: string;
  upcmingNotPresent: boolean = false;
  imageUrl = "";
  redirectUrl = "";
  showDefault = true;
  isTimeBoundTest: boolean = false;
  infoboxDetails: any = [];
  upcomingTestDetails: any;
  imageUrl_web: string;
  imageUrl_mob: string;
  imageUrl_tab: string;
  upcomingTestData: any = {};
  assementUtilityObject: any = {
    examSchedules: [],//this is already scheduled or enrolled exams,
    testimer: {},
    testTimerSubscription: {},
    unEnrolled_before_endTime:{}
  }
  filterCMSData = filterCMSData;
  displayGrade: number;
  sumAllCompletedInfoBox: Number =0;
  sumAllInfoBox: Number=0;
  showPypPDfBox:boolean = false;
  enablePypPdf:boolean = environment?.pypPdf;
  constructor(private dashboardService: DashboardService, private testListService: TestlistService,
    private userService: UserService, private storage: LocalStorageService, public router: Router,
    public dialog: MatDialog,
    public modalservice: NgbModal,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private gaService: GAnalyticsService,
    private scheduleService: ScheduleService,
    private communicationMessageService: CommunicationMessageService,
    private firebaseService: FirebaseService,
    private _eventHandlingService: EventHandlingService,
    private examService: ExamService,
    private firebaseAnalyticsService: FirebaseAnalyticsService,
    private cdRef: ChangeDetectorRef,
    private AchievementsService: MyactivityService,
  ) {
    this.token = localStorage.getItem('token')
    this.detail = this.userService.getMobileAndName();
    this.profilePhoto = this.detail?.profilePhoto;
    this.showBanner = curTenantDetails['showBanners'] && showBannerGrades.indexOf(String(this.detail?.grade)?.replace(/[^0-9]/ig, '')) > -1;
    this.showNewUserPopup = this.router.getCurrentNavigation()?.extras?.state?.newUser && this.showBanner;
  }

  ngOnInit(): void {
    if (environment.portal == 'teacher') {
      this.router.navigate(['/dashboard/liveclass'])
      return;
    }
    let selectdTab: any;
    selectdTab = localStorage.getItem('SelectedTab');
    if (selectdTab != 'assessment') {
      localStorage.setItem('SelectedTab', 'assessment');
    }
    let mobile_and_name: any = localStorage.getItem('mobile_and_name');
    let mobile_and_name_obj = JSON.parse(mobile_and_name);
    if (!localStorage.getItem('studentid')) {
      localStorage.setItem('studentid', mobile_and_name_obj.phone);
    }
    this.userService.loadUserDetails().subscribe((data) => {
      this.displayExamName= localStorage.getItem("targetExamName") as string;
      this.userData = data;
      this.displayGrade = parseInt(this.userData.grade.name)
      this.profilePhoto = data.profilePhoto
      this.initFunc();
    });

    this.testListService.examNameChanged.subscribe((examName: any) => {
      this.initFunc();
    })

    //dynamic ad image
    this.loadAds();
    this._eventHandlingService.changeFocusedExamFromHeader.subscribe((res) => {
      if (res && res.examName) {
        let examName: any = res?.examName?.replaceAll(' ', '')?.toUpperCase();
        this.examName = examName;
        localStorage.setItem('targetExamName', examName);
        this.initFunc();
        //dynamic ad image
        this.loadAds();
        this.getUpcomingTest();
      }
    })
    localStorage.removeItem('score-tracking-data');

    this.AchievementsService.badgeInvokeSubject.next("Assessment");
    if (this.enablePypPdf) {
      this.getUserGrade(this.detail?.grade);
    }
  }
  loadAds() {
    this.spinner.show();
    this.firebaseService.getImageData(this.displayExamName, this.userData?.grade?.name).then((resp) => {
      if (resp) {
        if (resp.web_url) {
          this.showDefault = false;
          this.imageUrl_web = resp.web_url;
          this.imageUrl_mob = resp.mob_url;
          this.imageUrl_tab = resp.tab_url;
        } else {
          this.showDefault = true;
        }

        if (resp.redirectUrl) {
          this.redirectUrl = resp.redirectUrl;
        } else {
          this.redirectUrl = "javascript:void(0);";
        }
      } else {
        this.showDefault = true;
      }
      this.spinner.hide();
    }).catch((err) => {
      this.spinner.hide();
    });
  }
  openFocusExamDialog() {
    const config: MatDialogConfig = {
      panelClass: `UNFAPP-mweb-btmstiky-modal`,
      data: { msg: this.examName },
    };
    const dialogRef = this.dialog.open(FocusExamComponent, config);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        // this.displayExamName = res.name;
        // this.selectedExam = res;
        let examName: any = res?.name?.replaceAll(' ', '')?.toUpperCase();
        this.examName = examName;
        localStorage.setItem('targetExamName', examName);
        // this.clickOnExam(this.selectedExam, 'liveclass');
        // this.getExamInfo();
        this.initFunc();
        //dynamic ad image
        this.loadAds();
        this.getUpcomingTest();
        this.testListService.examNameChange.next(true);
      }
    })
  }

  gotoPYP() {
    let examName = localStorage.getItem("targetExamName") as string;
    this.router.navigateByUrl(`/dashboard/testlist?examname=${examName}&examtype=PREVIOUSYEAR`);
  }

  attemptTest(testData, examType) {
    this.attemptTestNow(testData, getExamName(examType));
  }

  initFunc() {
    let examName = localStorage.getItem("targetExamName") as string;
    examName = (examName || "");
    this.displayExamName = examDisplayNames[examName];
    this.examName = examName;
    if (!this.userData?.exams?.length) return;
    const userGrade = this.userData?.grade?.name?.replace(/[^0-9]/g, '');
    if (allowedExamNamesCT[userGrade].indexOf(examName) < 0) {
      localStorage.setItem("targetExamName", this.examName = this.userData?.selectedExams[0]?.name?.replaceAll(" ", "")?.toUpperCase() || this.userData?.exams[0]?.name?.replaceAll(" ", "")?.toUpperCase());
    }
    this.spinner.show();
    this.testListService.getExamInfoBoxes().subscribe((oldData: any) => {
      setTimeout(() => {
        this.testListService.getV2Cards().subscribe((resp: any) => {
          this.testListService.cardsV2List = resp?.cards;
          this.infoBoxes = resp?.cards?.filter(v => v.isactive)?.map((box) => {
            let tempexamType = CMSTestType.find((ele) => ele.value == box.testtype[0])
            let findoldData = oldData.find(v => v.examtype == tempexamType?.name)
            box.examname = box.coursetype;
            box.examtype = tempexamType?.name;
            box.link = findoldData?.link ||'';
            box.paper = { totaltests: 0, completedtests: 0 }
            box.heading = box.title||'';
            box.logo = findoldData?.logo||'';
            box.value = tempexamType?.value;
            return box;
          }).sort((a, b) => a.order - b.order)
          // this.doTestCalculation();
          this.getUpcomingTest()//temporary added for upcoming box
          this.showInfoBox = true;
          this.report ={
            'totaltests': resp?.report?.totalTestsCount,
            'completedtests': resp?.report?.testsTaken,
            'totaltimespent': timeConvert(resp?.report?.totalTimeSpent||0),
            'highestscore': 0,
            'outofscore': 0
          }
        }, err => {
        this.spinner.hide();
        })
      }, 0)
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
    });


  }

  async doTestCalculation() {

    let infoBoxes = Object.assign(this.infoBoxes);


    let examName = localStorage.getItem("targetExamName") as string;
    let filterCMSData = this.filterCMSData();
    // let cmsExamData = filterCMSData?.find((ele) => ele?.CMS_Exam_Name == examName && ele?.UAM_grade_id == this.userData?.grade?.gradeId);
    const testsById: any = {};
    this.testListService.getPreviousAndPresentMockTests().subscribe(async (overallTests: any) => {
      overallTests = overallTests.filter((testData: any) => {
        if (testData.coursetype == "39694") {
          testData.coursetype = "JEEADVANCED";
        }
        if ((testData.coursetype || "").replaceAll(" ", "").toUpperCase().indexOf(examName) != -1) {
        // if (testData?.exam_type.indexOf(String(cmsExamData?.CMS_Exam_id)) != -1) {
          if (this.examName == "JEEADVANCED" || this.examName == "NTSE") {
            const scId = testData.scheduleid;
            if (!this.testsByScheduleId[scId]) {
              this.testsByScheduleId[scId] = [];
            }
            this.testsByScheduleId[scId].push(testData);
          }
          testsById[testData._id] = testData;
          testData.rank = 0;
          testData.percentile = 0;
          return true;
        } else {
          return false;
        }
      });


      /* for resume functionality of a test if he has already started the exam */
      var bodyForRedisCache: any = [];
      if (overallTests.length) {
        overallTests.forEach((testrow: any) => {
          // if(timeBoundTypes.indexOf(testrow.examtype) > -1) {
          bodyForRedisCache.push({
            "tenantid": this.tenant,
            "scheduleid": testrow.scheduleid,
            "ruleid": testrow._id,
            "studentid": localStorage.getItem('studentid')
            // "scheduleid": "62c77550cf69725d652407ae",
            // "ruleid": "62c77b89d86f8a8de29e726b-paper1",
            // "studentid": "7096827042"
          });
          // }
        });

        try {
          // let data = [{
          //   "tenantid": this.tenant,
          //   "scheduleid": "62c77550cf69725d652407ae",
          //   "ruleid": "62c77b89d86f8a8de29e726b-paper1",
          //   "studentid": "7096827042"
          // }]
          let redisResponses: any = await this.testListService.getResponsesForMultipleExams(bodyForRedisCache).toPromise();
          if (redisResponses && redisResponses.length) {
            redisResponses?.data.forEach((redisResponseData: any) => {
              if (testsById[redisResponseData.ruleid]) {
                testsById[redisResponseData.ruleid].resume = redisResponseData.status.length;
              }
            });
          }
        } catch (error) {
        }
      }

      /***********/
      this.overallTests = overallTests;

      this.testListService.getStudentExamResult().subscribe(async (allTestsbyStudent: any) => {
        let filterCMSData = this.filterCMSData();
        let cmsExamId = (examName != 'CBSE') ? filterCMSData?.find((ele : any) => ele?.CMS_Exam_Name?.replaceAll(' ', '').toUpperCase() == examName && ele?.UAM_Grade_Name == this.userData?.grade.name)
                                        : filterCMSData?.find((ele : any) => ele?.UAM_Exam_Name?.replaceAll(' ', '').toUpperCase() == examName && ele?.UAM_Grade_Name == this.userData?.grade.name)

        // let cmsExamId = filterCMSData?.find((ele : any) => ele?.CMS_Exam_Name.replaceAll(' ','').toUpperCase() == examName && ele?.UAM_Grade_Name == this.userData?.grade.name)
        this.attemptedTestsByScheduleId = {};
        allTestsbyStudent = allTestsbyStudent?.filter((test: any) => {
          if ((test.examtype || "").replaceAll(" ", "").toUpperCase().indexOf(cmsExamId?.CMS_Exam_id) != -1) {
          // if ((test.coursetype || "").replaceAll(" ", "").toUpperCase().indexOf(examName) != -1) {
            const testrow = testsById[test.testrule_id];
            if (testrow) {
              testrow.testtaken = true
              if (this.portal == 'SCORE' && testrow.examtype != 'MOCKTEST') {
                return false;
              }
              if (!this.attemptedTestsByScheduleId[test.testformat_id]) {
                this.attemptedTestsByScheduleId[test.testformat_id] = [];
              }
              this.attemptedTestsByScheduleId[test.testformat_id].push(test);
              // testrow.totaltimespend = test.totaltimespend
              // testrow.score = test.score
              // testrow.examsubmittedon = test.examsubmittedon
              // testrow.rank = test.rank ? test.rank : 0;
              // testrow.percentile = test.percentile ? test.percentile : 0;
              // testrow.questionanswer = test.questionanswer;
              this.totalScores[testrow._id] = test.grand_total.totalScore;//getTotalScore(test);
              return true;
            }
          }
        });

        this.studentExamResult = allTestsbyStudent;

        var examSchedules: any = [];
        try {
          let body = { "studentid": localStorage.getItem('studentid') };
          examSchedules = await this.scheduleService.getStudentExamSchedule(body).toPromise();
        } catch (error) {
        }

        if (examSchedules.length) {
          examSchedules.forEach((enrolledExamsDetails: any) => {
            if (this.overallTests.length) {
              const test = testsById[enrolledExamsDetails.ruleid];
              if (test) {
                test.enrolled = true
                this.enrolledExamsCount++;
              }
            }
          });
          this.assementUtilityObject.examSchedules = examSchedules;
        }

        await this.testListService.getFreeTrialDetails();
        this.infoBoxes.forEach((infoBox: any) => {

          const testsByScheduleId: any = {}, testsById: any = {}, attemptedTestsByScheduleId: any = {};
          let allTest = overallTests.filter((testData: any) => {


            // if (String(infoBox.examtype) && String(infoBox.examtype).indexOf(testData.exam_type[0]) != -1) {
            if ((infoBox?.value?.indexOf(testData?.test_type[0])) != -1) {
              if (this.examName == "JEEADVANCED" || this.examName == "NTSE") {
                const scId = testData.scheduleid;
                if (!testsByScheduleId[scId]) {
                  testsByScheduleId[scId] = [];
                }
                testsByScheduleId[scId].push(testData);
              }
              testsById[testData._id] = testData;
              return true;
            } else {
              return false;
            }
          });

          let exmTest = allTestsbyStudent.filter((test: any) => {
            const testrow = testsById[test.testrule_id];
            if (testrow) {
              if (!attemptedTestsByScheduleId[test.testformat_id]) {
                attemptedTestsByScheduleId[test.testformat_id] = [];
              }
              attemptedTestsByScheduleId[test.testformat_id].push(test);
              return true;
            } else {
              return false;
            }
          });

          infoBox.testLists = allTest;
          if (allTest.length) {
            infoBox.attemptedTestNumber = allTest.filter((test: any) => {
              return test.testtaken || test.resume;
            }).length;
          }
          if (this.examName == "JEEADVANCED" && infoBox.examtype != 'SCHLARSHIPTEST') {
            this.calculateForJEEADV({ examName: this.examName, detailedReportPaper: 'Combined', overallTests: allTest, testsByScheduleIdIn: testsByScheduleId, studentExamResultIn: exmTest, attemptedTestsByScheduleIdIn: attemptedTestsByScheduleId, report: infoBox.paper, totalScores: this.totalScores, timeNeeded: false, highestScoreNeeded: false });
          } else {
            infoBox.paper.totaltests = allTest.length;
            if(infoBox.shortname != 'SCORE'){
              this.sumAllInfoBox += allTest.length
              this.sumAllCompletedInfoBox +=exmTest.length
            }
            infoBox.paper.completedtests = exmTest.length;
          }
        });
        if (this.examName == "JEEADVANCED") {
          this.calculateForJEEADV({ examName: this.examName, detailedReportPaper: this.detailedReportPaper, overallTests: this.overallTests, testsByScheduleIdIn: this.testsByScheduleId, studentExamResultIn: this.studentExamResult, attemptedTestsByScheduleIdIn: this.attemptedTestsByScheduleId, report: this.report, totalScores: this.totalScores });
        } else {
          this.report.totaltests = this.sumAllInfoBox
          let timeSpentInMin = allTestsbyStudent.reduce((totalTime: any, test: any) => {
            if (test.grand_total.timespent) {
              return totalTime + test.grand_total.timespent;
            } else {
              return totalTime + 0;
            }
          }, 0);
          this.report.totaltimespent = timeConvert(timeSpentInMin);
          this.report.completedtests = this.sumAllCompletedInfoBox

          let highestScore = 0;
          let highestScoreTestId;
          if (allTestsbyStudent.length) {
            highestScore = -99999;
            allTestsbyStudent?.forEach((e) => {
              let score = e?.grand_total.score || 0;
              if (score >= highestScore) {
                highestScore = score;
                highestScoreTestId = e.testrule_id;
              }
            });
          }


          if (highestScoreTestId) {
            this.report.highestscore = highestScore;
            this.report.outofscore =
              this.totalScores[highestScoreTestId];
          }
        }
        if (this.report.completedtests == 0) {
          this.gaService.sendEvent(
            'dashboard_reached_with_0_tests',
            'new_user_tests',
            'dashboard_reached_with_0_tests',
            'reached_dashboard',
          );
        }
        this.infoBoxes = infoBoxes;

        this.infoBoxes.forEach((element) => {                      // first two tests of timebound
          if ((element?.examtype === 'GRANDTEST' || element?.examtype === 'SCHOLARSHIPTEST' || element?.examtype === 'TIMEBOUND' || element?.examtype === 'New NEET Timebound') && element?.testLists.length > 0) {
            let serverTime = localStorage.getItem('serverTime') + '000';
            let serverTimeNow = Number(serverTime);


            let testsUnattempeted = element.testLists.filter(eachTest => !(eachTest.testtaken) && !isCurrentTimeGreaterExamEndtime(eachTest, serverTimeNow));

            let upcomingTests = testsUnattempeted.filter((testData: any) => {
              let testStartTimeInt = parseInt(moment(testData.span, "YYYY-MM-DD hh:mm A").format("YYYYMMDDHHmm"));
              let serverTime = localStorage.getItem('serverTime');
              let current_time = parseInt(moment.unix(Number(serverTime)).format("YYYYMMDDHHmm"));
              return testStartTimeInt <= current_time;
            });


            testsUnattempeted = upcomingTests.slice(0).sort((a: any, b: any) => {
              let aSpan = moment(a.span, "YYYY-MM-DD hh:mm A").format("YYYYMMDDHHmmss");
              let bSpan = moment(b.span, "YYYY-MM-DD hh:mm A").format("YYYYMMDDHHmmss");
              return parseInt(bSpan) - parseInt(aSpan)
            });



            // if (this.infoboxDetails.length <= 2){
            if (testsUnattempeted.length > 0) {
              this.isTimeBoundTest = true;
              this.infoboxDetails.push({
                ...testsUnattempeted[0],
                ...element
              });
            }
            if (testsUnattempeted.length > 1) {
              this.infoboxDetails.push({
                ...testsUnattempeted[1],
                ...element
              });
            }

            this.infoboxDetails.forEach(element => {
              element['isSubscriptionEnd'] = this.testListService.checkResumeNowandFreePaper(element.coursetype,element.examtype) || false;
              // this.testListService.isUserSubscribed(element.examtype, [element]).then((resp: any) => {
              //   if (resp) {
              //     element['isSubscriptionEnd'] = resp;
              //     return;
              //   }
              // });
            })

            return false;
            // }
          }
        });



        this.updateTimeboundTests(this);
        if (this.showNewUserPopup) {
          // this.newUserDialog();
        }
        this.showInfoBox = true;
        this.getUpcomingTest()
        this.spinner.hide();
        this.cdRef.detectChanges();
      })
    })
  }

  // newUserDialog() {
  //   let ngbModalOptions: NgbModalOptions = {
  //     keyboard: false,
  //     windowClass: 'ASM_start_learn_modal-content'
  //   };
  //   const modalComp = this.modalservice.open(StartLearnModalComponent, ngbModalOptions);
  //   // modalComp.componentInstance.examMeta = {
  //   //   coursetype: this.examName,
  //   //   examtype: this.examtype,
  //   //   grade: this.detail?.grade,
  //   //   data: this.schedulesData
  //   // };
  //   modalComp.result.then((d: any) => {
  //     this.showNewUserPopup = false;
  //     if(d?.navigate) {
  //       let targetExamName = localStorage.getItem('targetExamName');
  //       this.testListService.gotoLCFromASM({targetExamName});
  //     } else if(d?.pyp) {
  //       this.gotoPYP();
  //     }
  //   });
  // }

  testRegistered(evt: any) {
    let { tests = [], examtype } = evt;

    this.overallTests.forEach((test: any) => {
      tests.forEach(element => {
        if (element._id == test._id) {
          test.enrolled = true;
          this.enrolledExamsCount++;
        }
      });
    });
    if (this.latestTimeboundTests[examtype]) {
      this.latestTimeboundTests[examtype] = {
        ...this.latestTimeboundTests[examtype],
        enrolled: true
      }
    }
    this.upcomingTestDetails.forEach((eachTest: any) => {
      tests.forEach(test => {
        if (eachTest._id == test._id) {
          eachTest.already_enrolled = true;
          // this.enrolledExamsCount++;
        }
      });
    });
  }

  updateTimeboundTests(thisRef): boolean {
    let timeboundTestsExist;
    if (thisRef.latestTimeboundTestInterval) {
      clearTimeout(thisRef.latestTimeboundTestInterval);
    }
    timeBoundTypes.forEach(e => {
      if (thisRef.latestTimeboundTests[e]) {
        thisRef.latestTimeboundTests[e] = {
          ...thisRef.latestTimeboundTests[e],
          updated: !thisRef.latestTimeboundTests[e].updated
        }
      }

      let serverTime = localStorage.getItem('serverTime') + '000';
      let serverTimeNow = Number(serverTime);
      let timeBoundTests = thisRef.overallTests.filter((testData: any) => {
        if (testData.examtype == e) {
          return !isCurrentTimeGreaterExamEndtime(testData, serverTimeNow);
          //return !isCurrentTimeGreaterExamEndtime(testData, serverTimeNow);
        } else {
          return false;
        }
      });

      let timeBoundTestSortByDate: any = [];
      if (timeBoundTests.length) {
        timeboundTestsExist = true;
        timeBoundTestSortByDate = timeBoundTests.slice(0).sort((a: any, b: any) => {
          //@ts-ignore
          return getDateFromTestSpan(a.span) - getDateFromTestSpan(b.span);
        });
        let prevId = thisRef.latestTimeboundTests[e]?._id;
        let enrolled = thisRef.latestTimeboundTests[e]?.enrolled;
        thisRef.latestTimeboundTests[e] = timeBoundTestSortByDate[0];
        if (thisRef.latestTimeboundTests[e]._id == prevId) {
          thisRef.latestTimeboundTests[e] = {
            ...thisRef.latestTimeboundTests[e],
            enrolled
          }
        }
      }
    });
    if (timeboundTestsExist) {
        thisRef.latestTimeboundTestInterval = new TaskTimer(10000);
        thisRef.latestTimeboundTestInterval.add({id: 'latestTimebound',totalRuns: 1, callback(task) {
          thisRef.updateTimeboundTests(thisRef);
        }}).start();
    }
    return timeboundTestsExist;
  }

  ngOnDestroy() {
    if (this.latestTimeboundTestInterval) {
      clearTimeout(this.latestTimeboundTestInterval);
      this.latestTimeboundTestInterval = null;
    }
    if (this.assementUtilityObject.testTimerSubscription && Object.keys(this.assementUtilityObject.testTimerSubscription)?.length) {
      Object.keys(this.assementUtilityObject.testTimerSubscription)?.forEach((element) => {
        this.assementUtilityObject.testTimerSubscription[element].unsubscribe();
      })
    }
    this.unEnrollGraceSubscription()
  }
  unEnrollGraceSubscription() {
    if (this.assementUtilityObject.unEnrolled_before_endTime && Object.keys(this.assementUtilityObject.unEnrolled_before_endTime)?.length) {
      Object.keys(this.assementUtilityObject.unEnrolled_before_endTime)?.forEach((element) => {
        this.assementUtilityObject.unEnrolled_before_endTime[element].unsubscribe();
      })
    }
  }
  upcmingNotPresents() {
    this.upcmingNotPresent = true;
  }

  /* Upcoming test  limited to top 2 nearest time */
  getUpcomingTest() {
    let cmsDetails = this.filterCMSData();
    let cmsExamIds = cmsDetails.map(e => String(e.CMS_Exam_id));
    let cmsGradeIds = cmsDetails.map(e => e.CMS_grade_id);
    let data = {
      classes: cmsGradeIds[0],
      exam_type: String(cmsExamIds[0]),
      studentid: localStorage.getItem('studentid')
    }
    // let data = {
    //   classes:6,
    //   exam_type: "40",f
    //   studentid: localStorage.getItem('studentid')
    // }
    this.testListService.getMySubscriptionWithFreeCount()
    this.testListService.getUpcomingTestV2(data).subscribe((res:any) => {
      // this.upcomingTestDetails = res?.filter((upcomintest)=> {
      //   return  this.studentExamResult?.find((attTest)=>attTest?.ruleid == upcomintest?._id ) ? false : true
      //  });
      this.upcomingTestDetails = res;
      if (this.upcomingTestDetails.length > 0) {

        this.upcomingTestDetails.forEach(element => {
          // element.examtype=element?.test_type[0].name;//?setting examtype
          let testtype = Array.isArray(element?.test_type)?element?.test_type[0]:element?.test_type
          element._id = element?.id;
          element.FormatedDateTime = this.displayFormatedDateTime(element);
          element.availableForAttempt = this.availableForAttempt(element);
          element.timedifference_ms = this.timeDifferencetestTimeandserver(element)
          element.canregister_to_test = this.canRegisterTimeChecking(element);
          element.already_enrolled = (element?.status?.toUpperCase() == 'REGISTERED' ||element?.status?.toUpperCase() == 'INPROGRESS')? true : false; // this.assementUtilityObject?.examSchedules?.some(v => v.ruleid == element._id);
          element.isTimebound = timeBoundTypes.some(v => v == getExamName(testtype))
          element.examtype = testtype;
          element.resume =  element?.status?.toUpperCase() == 'INPROGRESS' ? true : false;
          element['isSubscriptionEnd'] = element?.subscribeStatus||false//this.testListService.checkResumeNowandFreePaper(getCourseName(element.exam_type),getExamName(element?.test_type[0])) || false;
          // this.testListService.isUserSubscribed(element?.examtype, [element]).then((resp: any) => {
          //   element['isSubscriptionEnd'] = resp;
          // });
        });
        // this.upcomingTestDetails = this.upcomingTestDetails?.filter(v => v.canregister_to_test )?.filter((exams: any) => timeBoundTypes?.indexOf(getExamName(exams?.test_type)) !== -1);//filter avaible timeslots then by time bound test
        this.upcomingTestDetails = this.upcomingTestDetails?.filter((exams: any) => timeBoundTypes?.indexOf(getExamName(exams?.test_type)) !== -1)?.filter(v=>v?.already_enrolled || v?.canregister_to_test);//filter avaible timeslots then by time bound test
        this.upcomingTestDetails.forEach((test: any) => {
          if (test.already_enrolled && !test.availableForAttempt) { //checks already registered  and not lying in 10 min range
            this.changeStatusOfButton(test)
          } if (!test.already_enrolled && test.availableForAttempt) { //checks not registered  and not lying in 10 min range
            this.exams_graceLimit_passed(test)
          }
        })
        if(this.examName =='JEEADVANCED'){
           this.upcomingTestDetails?.forEach((v,i,self)=>{
            let allschdules = [...res?.filter(inv=>v.scheduleid = inv.scheduleid)]?.map(v=> {
              return new TestTypeconstructor(v)
            })
            v.displayStartEndDate=  totalTimeTakebySchdule(allschdules)
            v.allScheduleids = allschdules;
          });
          if(this.upcomingTestDetails?.every(v=>v?.status == "PUBLISHED")){
            this.upcomingTestDetails = this.upcomingTestDetails?.filter((item,index,self) => self.findIndex(inv => inv?.subruleid === item?.subruleid) == index );
          }
          else{
            this.upcomingTestDetails.forEach(v=>{
              v.papername = v.id.split('-')[1];
              v.displayStartEndDate =v.FormatedDateTime
           })
          }
          }
        // this.studentExamResult?.forEach(res => {
        //   this.upcomingTestDetails?.forEach(element => {
        //     if (res?.testrule_id == element?._id) {
        //       element.testtaken = true;
        //     }
        //   });
        // });
        // this.upcomingTestDetails = this.upcomingTestDetails.filter((ele) => !ele?.testtaken);
        // var bodyForRedisCache: any = [];
        // if (this.upcomingTestDetails?.length) {
        //   this.upcomingTestDetails?.forEach((testrow: any) => {
        //     bodyForRedisCache.push({
        //       "tenantid": this.tenant,
        //       "scheduleid": testrow.scheduleid,
        //       "ruleid": testrow._id,
        //       "studentid": localStorage.getItem('studentid')
        //     });
        //   })
        // }
        // this.testListService.getResponsesForMultipleExams(bodyForRedisCache).subscribe((res) => {
        //   res = res?.filter((test: any) => { return test?.status?.length}).map((test) => {return test?.ruleid})
        //   res?.forEach(ruleid => {
        //     this.upcomingTestDetails?.forEach(element => {
        //       if (ruleid == element?._id) {
        //         element.resume = true;
        //       }
        //     });
        //   });
        // })
      }
    })
  }
  /* change the nroll option to Register based on settimeout for particular test */
  changeStatusOfButton(test) {
    this.assementUtilityObject.testTimerSubscription[test._id] = timer(test?.timedifference_ms).subscribe(() => {
      let index = this.upcomingTestDetails.findIndex(v => v._id == test?._id)
      this.upcomingTestDetails[index].availableForAttempt = true;
    })
  }
  exams_graceLimit_passed(test) {
    let time_before_examend = moment(test?.span,'YYYY-MM-DD hh:mm A').add(+test?.duration - examgraceTimeConstant, 'minutes')
    let refreshingTime =time_before_examend.diff( moment(),'milliseconds')
    if ( (refreshingTime  > 0 && refreshingTime < 14400001) || refreshingTime == 0 ) {
      if( this.assementUtilityObject.unEnrolled_before_endTime[test._id]){
        this.assementUtilityObject.unEnrolled_before_endTime[test._id].unsubscribe()
      }
      this.assementUtilityObject.unEnrolled_before_endTime[test._id] = timer(refreshingTime).subscribe(() => {
        let index = this.upcomingTestDetails.findIndex(v => v._id == test?._id)
        this.upcomingTestDetails[index].availableForAttempt = false;
        this.upcomingTestDetails[index].canregister_to_test = false;
        if(this.examName =='JEEADVANCED'){
          this.unEnrollGraceSubscription();
          this.testListService.getServerTime().then((resp)=>{
            this.getUpcomingTest();
          })
        }else{
          this.upcomingTestDetails = this.upcomingTestDetails?.filter(v=>v?.already_enrolled || v?.canregister_to_test);
        }
      })
    }
  }

  getExamQuestion(test) {

    // let examInfo = test;
    let subjectsdata = [];
    const postdata = {
      scheduleid: test.scheduleid,
      ruleid: test._id,
      clearcache: true
    }
    this.spinner.show();
    this.testListService.getExamQuestion(postdata).subscribe((allTestsbyStudent: any) => {

      let subData = allTestsbyStudent?.questions.subjects;
      if (subData) {
        subData.forEach((sub) => {
          subjectsdata.push({ subjectname: sub.subjectname, subjectquestions: sub.questions?.length });
        })
      }
      this.upcomingTestData['subjectsdata'] = subjectsdata;
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
    });
  }
  fireBaseUserDetailsTrackingForTests(){
    var objData = this.firebaseService.getFireBaseEventUserDetails();
    if(this.showDefault == false){
      objData["banner_navigation"] =this.redirectUrl;
      }
    this.firebaseAnalyticsService.postEvent("Banner_test" , objData);
  }

  // * G10 pyp detail section */
  getUserGrade(ev) {
    let targetExam = localStorage.getItem("targetExamName");
    //TOdo if user grade==10 show them pdf list
    if (ev == 10 && targetExam == 'CBSE') {
    // this.showPypPDfBox = true; //? as we are getting the card from the API disabling this
    }
  }
  gotoPdfList(){
    let examName = localStorage.getItem("targetExamName") as string;
    this.router.navigateByUrl(`/dashboard/testlist?examname=${examName}&examtype=PREVIOUSYEAR`);
  }
}
export function TestTypeconstructor(v){

    this["id"]=v?.id,
  this["scheduleid"]=v?.scheduleid,
  this["schedulename"]=v?.schedulename,
  this["description"]=v?.description,
  this["rulename"]=v?.rulename,
  this["status"]=v?.status,
  this["exam_type"]=v?.exam_type,
  this["duration"]=v?.duration,
  this["exam_time"]=v?.exam_time,
  this["span"]=v?.span,
  this["test_type"]=v?.test_type,
  this["_id"]=v?._id,
  this["availableForAttempt"]=v?.availableForAttempt,
  this["timedifference_ms"]=v?.timedifference_ms,
  this["canregister_to_test"]=v?.canregister_to_test,
  this["already_enrolled"]=v?.already_enrolled,
  this["isTimebound"]=v?.isTimebound,
  this["examtype"]=v?.examtype,
  this["resume"]   =v?.resume,
  this["subruleid"] =v?.subruleid

}
